import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>© {year} KRJ. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
